/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Header, Order } from 'interface/cmn/commonInfo';
import { IClassificationProps, IInspectionDetail3Info2Props, ToggleValue } from 'interface/inspection/InspectionInfo';
import { IPostCompJoin, IPostLogin } from 'interface/login/loginInfo';
import { IInspectionIpsativesProps } from 'interface/project/projectInfo';
import isEmpty from 'lodash/isEmpty';

export function makeHeader(token?: string): Header {
  let requestHeader: Header = {
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
  };

  if (token !== undefined && token !== null) {
    requestHeader = {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        Authorization: `Bearer ${token}`,
      },
    };
  }
  return requestHeader;
}

export function makeMultipartFormDataHeader(token?: string): Header {
  let requestHeader: Header = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  if (token !== undefined && token !== null) {
    requestHeader = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    };
  }
  return requestHeader;
}

export function makeData(email: string, password: string): IPostLogin {
  const requestBody: IPostLogin = {
    email,
    password,
  };

  return requestBody;
}

export function makeJoinData({
  email,
  password,
  name,
  mobile,
  compName,
  compRole,
  compBizNum,
}: IPostCompJoin): IPostCompJoin {
  const requestBody: IPostCompJoin = {
    email,
    password,
    name,
    mobile,
    compName,
    compRole,
    compBizNum,
  };

  return requestBody;
}

export const handleIsEmail = (email: string): boolean => {
  const regExp = /^([^<>()\\[\].,;:\s@"]+(\.[^<>()\\[\].,;:\s@"]+)*)@([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}$/;
  return regExp.test(String(email).toLowerCase());
};

export const handleIsMobile = (value: string): boolean => {
  const regPhone = /^010[-]?\d{4}[-]?\d{4}$/;

  let result = false;
  result = regPhone.test(value);

  if (result) {
    const spaceCheck = /\s/g;
    if (value.match(spaceCheck)) {
      result = false;
    }
  }
  return result;
};

export const handlePasswordValidate = (value: string): boolean | string => {
  const checkUpperCase = /[A-Z]/.test(value);
  const checkSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
  const checkLowerCase = /[a-z]/.test(value);
  const minLength = value.length >= 12;

  if (!checkUpperCase || !checkSpecialChar || !checkLowerCase || !minLength) {
    return '비밀번호는 12자 이상이며, 대문자, 소문자, 특수문자를 포함해야 합니다.';
  }

  return true;
};
export const handleConfirmPasswordValidate = (password: string, confirmPassword: string): boolean | string => {
  if (password === confirmPassword) {
    return true;
  }
  return '비밀번호가 일치하지 않습니다.';
};

export const handleEmailValidate = (value: string): boolean | string => {
  if (!handleIsEmail(value)) {
    return '이메일 형식에 맞게 입력해주세요.';
  }
  return true;
};

export const handleMobileValidate = (value: string): boolean | string => {
  if (handleIsMobile(value) && value.length === 11) {
    return true;
  }
  return '휴대폰 번호 11자리를 입력해주세요';
};

export const formFields = [
  {
    id: 'name',
    label: '이름(실명)',
    placeholder: '회원가입 후 이름은 변경할 수 없습니다.',
    type: 'text',
    required: true,
  },
  {
    id: 'email',
    label: '이메일',
    placeholder: '회원가입 후 이메일은 변경할 수 없습니다.',
    type: 'text',
    required: true,
    validate: handleEmailValidate,
  },
  {
    id: 'mobile',
    label: '전화번호',
    placeholder: '전화번호를 입력하세요.',
    type: 'text',
    required: true,
    validate: handleMobileValidate,
  },
  {
    id: 'password',
    label: '비밀번호',
    placeholder: '비밀번호는 특수기호와 대문자 소문자 조합 12자 이상으로 생성해주세요.',
    type: 'password',
    required: true,
    validate: handlePasswordValidate,
  },
  {
    id: 'confirmPassword',
    label: '비밀번호 확인',
    placeholder: '',
    type: 'password',
    required: true,
  },
  { id: 'compName', label: '소속(기업명)', placeholder: '기업명', type: 'text', required: true, tooltip: true },
  {
    id: 'compRole',
    label: '직급/직책',
    placeholder: '직급과 직책을 /로 구분해서 입력해주세요. ',
    type: 'text',
    required: true,
    tooltip: true,
  },
];

export const handleLoginPasswordCheck = (value: string): boolean | string => {
  if (value.length >= 1 && value.length < 4) {
    return '비밀번호는 4자 이상 입력해주세요.';
  }
  return true;
};

export const accountFields = [
  {
    id: 'name',
    label: '이름(실명)',
    placeholder: '회원가입 후 이름은 변경할 수 없습니다.',
    type: 'text',
    disabled: true,
  },
  {
    id: 'email',
    label: '이메일',
    placeholder: '회원가입 후 이메일은 변경할 수 없습니다.',
    type: 'text',
    disabled: true,
  },
  {
    id: 'mobile',
    label: '전화번호',
    placeholder: '전화번호를 입력하세요.',
    type: 'text',
    required: true,
    validate: handleMobileValidate,
  },
  {
    id: 'password',
    label: '비밀번호',
    placeholder: '비밀번호는 특수기호와 대문자 소문자 조합 12자 이상으로 생성해주세요.',
    type: 'password',
    disabled: true,
  },
  { id: 'compName', label: '소속(기업명)', placeholder: '기업명', type: 'text', required: true },
  {
    id: 'compRole',
    label: '직급/직책',
    placeholder: '직급과 직책을 /로 구분해서 입력해주세요. ',
    type: 'text',
    required: true,
  },
];

export const passwordDialog = [
  {
    id: 'originPassword',
    label: '기존 비밀번호',
    placeholder: '기존 비밀번호를 입력해주세요.',
    type: 'password',
    required: true,
  },
  {
    id: 'password',
    label: '새 비밀번호',
    placeholder: '비밀번호는 특수기호와 대문자 소문자 조합 12자 이상으로 생성해주세요.',
    type: 'password',
    required: true,
    validate: handlePasswordValidate,
  },
  {
    id: 'confirmPassword',
    label: '새 비밀번호 확인',
    placeholder: '',
    type: 'password',
    required: true,
  },
];

export function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number): T[] {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export function getComparatorAny<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (a: { [key in Key]: unknown }, b: { [key in Key]: unknown }) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T): number {
  return 0;
}
export const informationSteps = [
  '프로젝트 정보입력',
  '진단도구 설정',
  '추가문항 설정',
  '안내문구 설정',
  '프로젝트 정보 확인',
];
export const informationDCSteps = [
  '프로젝트 정보입력',
  '그리드 설정',
  '추가문항 설정',
  '안내문구 설정',
  '프로젝트 정보 확인',
];
export function handleFormatDate(date: string): string {
  if (!date || date.length !== 8) {
    return '';
  }

  return `${date.substring(0, 4)}.${date.substring(4, 6)}.${date.substring(6, 8)}`;
}
export const handleRandomAlpha = (length = 4) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
};
export const hanldeFormatDate = (_date: string) => {
  if (isEmpty(_date)) {
    return '-';
  }
  const date = new Date(_date);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}.${month}.${day} ${hours}:${minutes}`;
};

export const getValueColor = (value: string): string => {
  const infoMap: {
    [key: string]: string;
  } = {
    NN: '#ff0000',
    N: '#ffa500',
    A: '#00ff00',
    AA: '#0088ff',
  };
  return infoMap[value] ?? 'red';
};

export const getValueText = (value: string): string => {
  const infoMap: {
    [key: string]: string;
  } = {
    NN: '전혀 동의하지 않음',
    N: '동의하지 않음',
    A: '동의함',
    AA: '전적으로 동의함',
  };
  return infoMap[value] ?? '-';
};

export const handleCategoryInitData = [
  { id: 'NN', name: '전혀 동의하지 않음', color: '#ff0000' },
  { id: 'N', name: '동의하지 않음', color: '#ffa500' },
  { id: 'A', name: '동의함', color: '#00ff00' },
  { id: 'AA', name: '전적으로 동의함', color: '#0088ff' },
];

export const handleGetClassificationEndMsg = (step: string): string[] => {
  const infoMap: Record<string, string[]> = {
    '1': ['1차 분류가 종료되었습니다.', '다음 버튼을 눌러 2차 분류를 진행합니다.'],
    '2_1': ['2단계 분류 PART 1이 종료되었습니다.', '다음 버튼을 눌러 2단계 분류 PART 2를 진행합니다.'],
    '2_2': ['2단계 분류 PART 2가 종료되었습니다.', '다음 버튼을 눌러 2단계 분류 PART 3을 진행합니다.'],
    '2_3': ['2단계 분류 PART 3이 종료되었습니다.', '다음 버튼을 눌러 2단계 분류 PART 4를 진행합니다.'],
    '2_4': ['2단계 분류 PART 4가 종료되었습니다.', '다음 단계로 진행합니다.'],
  };
  return infoMap[step] ?? ['-', '-'];
};
export const handleParentValue = (
  sort: number,
  NNCount: number,
  NCount: number,
  ACount: number,
  AACount: number,
): ToggleValue => {
  let result: ToggleValue = '';
  const tmp = sort + 1;
  if (tmp <= AACount) {
    result = 'AA';
  } else if (tmp <= AACount + ACount) {
    result = 'A';
  } else if (tmp <= AACount + ACount + NNCount) {
    result = 'NN';
  } else if (tmp <= AACount + ACount + NNCount + NCount) {
    result = 'N';
  }
  return result;
};
export const getGroupCounts = (infoArray: IClassificationProps[]) => {
  // console.log(
  //   '데이터 확인:',
  //   infoArray.map(item => item.value),
  // );
  return infoArray.reduce<Record<string, number>>((acc, item) => {
    acc[item.value as string] = (acc[item.value as string] || 0) + 1;
    return acc;
  }, {});
};

export const handleSortGroup = (
  infoArray: IClassificationProps[],
): {
  NNInfo: IClassificationProps[];
  NInfo: IClassificationProps[];
  AInfo: IClassificationProps[];
  AAInfo: IClassificationProps[];
} => {
  const NNInfo = infoArray.filter(obj => obj.value === 'NN');
  const NInfo = infoArray.filter(obj => obj.value === 'N');
  const AInfo = infoArray.filter(obj => obj.value === 'A');
  const AAInfo = infoArray.filter(obj => obj.value === 'AA');

  return { NNInfo, NInfo, AInfo, AAInfo };
};

export const countByArray = (arr: any): any => {
  return arr.reduce((prev: any, curr: any) => {
    prev[curr] = ++prev[curr] || 1;
    return prev;
  }, {});
};
export const getKeysWithArrays = (info: IInspectionDetail3Info2Props, conditionCount: number) => {
  const result: Record<string, IInspectionIpsativesProps[]> = {};

  Object.keys(info).forEach(key => {
    const array = info[key as keyof IInspectionDetail3Info2Props];
    if (array.length >= conditionCount) {
      result[key] = array;
    }
  });
  return handleSortArray(result);
};

const sortOrder = [
  'NNTempNNInfo',
  'NNTempNInfo',
  'NNTempAInfo',
  'NNTempAAInfo',
  'NTempNNInfo',
  'NTempNInfo',
  'NTempAInfo',
  'NTempAAInfo',
  'ATempNNInfo',
  'ATempNInfo',
  'ATempAInfo',
  'ATempAAInfo',
  'AATempNNInfo',
  'AATempNInfo',
  'AATempAInfo',
  'AATempAAInfo',
];
export const handleSortArray = (obj: Record<string, IInspectionIpsativesProps[]>) => {
  const result = {} as Record<string, IInspectionIpsativesProps[]>;

  sortOrder.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key as keyof IInspectionDetail3Info2Props] = obj[key];
    }
  });

  return result;
};
export const handleClassificationTitle = (classification: string, n?: number, g?: number): string => {
  const infoMap: Record<string, string> = {
    '1': '1단계 분류 (전반적 의견 분류)',
    '2_1': '2단계 분류 PART1',
    '2_2': '2단계 분류 PART2',
    '2_3': '2단계 분류 PART3',
    '2_4': '2단계 분류 PART4',
    '3': `3단계 분류 ${n}/${g}`,
  };
  return infoMap[classification] ?? '';
};
